import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppInfo, useUpdateDepartment } from '@/features/app/hooks';
import { Card } from '@/components/ui/Card';
import { inputClass } from '@/components/ui/Field';

/** Admin-only edit of the general department shown in the header. */
export function DepartmentCard() {
  const { t } = useTranslation();
  const { data } = useAppInfo();
  const update = useUpdateDepartment();
  const [value, setValue] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (data?.department) setValue(data.department);
  }, [data?.department]);

  const save = () => {
    const v = value.trim();
    if (!v) return;
    update.mutate(v, { onSuccess: () => setSaved(true) });
  };

  return (
    <Card className="flex flex-col gap-2.5 p-4">
      <h2 className="text-base font-bold">{t('settings.department')}</h2>
      <input
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setSaved(false);
        }}
        className={inputClass}
      />
      <span className="text-xs text-conduril-muted">{t('settings.departmentHint')}</span>
      {saved && (
        <div className="rounded-xl border border-green-300 bg-green-50 px-3.5 py-2.5 text-sm text-green-800">
          {t('settings.saved')}
        </div>
      )}
      <button
        type="button"
        onClick={save}
        disabled={update.isPending}
        className="min-h-[44px] rounded-lg bg-conduril-tint py-2.5 text-sm font-semibold hover:brightness-95 disabled:opacity-60"
      >
        {t('settings.save')}
      </button>
    </Card>
  );
}
